import React, { useState } from 'react';

import { ShareAbout } from '../components';

const Share: React.FC = () => {
  return (
    <ShareAbout />
  );
}

export default Share;
